<template>
  <el-dialog
    :visible.sync="visible"
    title="供应商信息维护"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1200px"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="名称：" prop="name">
            <el-input
              v-model="dataForm.name"
              placeholder=""
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="供应商类型："
            prop="categoryKey"
            size="mini"
          >
            <el-select v-model="dataForm.categoryKey" style="width:100%;">
              <el-option value="工厂" label="工厂"></el-option>
              <el-option value="原材料" label="原料/辅料"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="备注：" prop="remark">
            <el-input
              v-model="dataForm.remark"
              placeholder=""
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="期初余额：" prop="beginAmount" >
            <el-input
                v-model="dataForm.beginAmount"
                placeholder=""
                size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="省份：" prop="province">-->
<!--            <el-input-->
<!--              v-model="dataForm.province"-->
<!--              placeholder=""-->
<!--              size="mini"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
      </el-row>
      <el-row :gutter="16">
<!--        <el-col :span="12">-->
<!--          <el-form-item label="联系方式：" prop="contact1" >-->
<!--            <el-input-->
<!--                v-model="dataForm.contact1"-->
<!--                placeholder=""-->
<!--                size="mini"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
<!--        </el-col>-->

      </el-row>

      <el-form-item label="标签：" prop="category" size="mini">
        <el-checkbox-group v-model="categoryList">
          <el-checkbox label="印染"></el-checkbox>
          <el-checkbox label="坯布"></el-checkbox>
          <el-checkbox label="色织"></el-checkbox>
          <el-checkbox label="毛皮"></el-checkbox>
          <el-checkbox label="服装"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div
        class="flex"
        style="padding-left: 30px; align-items: center; margin-bottom: 20px"
      >
        <div style="font-weight: bold; margin-right: 20px; font-size: 14px">
          开票信息
        </div>
        <el-button type="text" @click="addReceipt" size="mini"
          >增加开票信息</el-button
        >
      </div>
      <el-row
        :gutter="16"
        v-for="(item, index) in dataForm.receiptList"
        :key="index"
      >
        <el-col :span="7">
          <el-form-item label="户头名：" label-width="70px">
            <el-input
                v-model="dataForm.receiptList[index].accountName"
                placeholder=""
                size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="开户银行：" label-width="100px">
            <el-input
              v-model="dataForm.receiptList[index].bankName"
              placeholder=""
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="银行账号：" label-width="100px">
            <el-input
              v-model="dataForm.receiptList[index].taxCode"
              placeholder=""
              size="mini"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button type="text"  @click="removeReceipt(index)"
            >删除</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import {moneyValidator} from '@/utils/validate'

export default {
  props: {
    categoryKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {},
      categoryList: [],
    };
  },
  computed: {
    dataRule() {
      return {
        beginAmount:[
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],
        categoryKey: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    removeReceipt(index) {
      this.dataForm.receiptList.splice(index, 1);
    },
    addReceipt() {
      this.dataForm.receiptList.push({
        accountName: "",
        taxCode: "",
      });
    },
    reset() {
      this.dataForm = {
        id: "",
        name: "",
        type: "",
        remark: "",
        category: "",
        categoryKey: "",
        province: "",
        beginAmount:0,
        receiptList: [
          {
            bankName:'',
            accountName: "",
            taxCode: "",
          },
        ],
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].clearValidate();
      }
    },
    init() {
      this.visible = true;
      this.$nextTick(() => {
        this.reset();
        if (this.id) {
          this.getInfo();
        }
      });
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/trade/company/${this.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          if (res.data) {
            if (res.data.category) {
              this.categoryList = res.data.category.split(",");
            }
            if(res.data.remark){
              try{
                res.data.remark=JSON.parse(res.data.remark)
                if(res.data.remark){
                  res.data.remark=res.data.remark.join(',')
                }
              }catch(e){
                console.log(e)
              }

            }
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
        })
        .catch(() => {});
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          let postForm = {
            ...this.dataForm,
            category: this.categoryList.join(","),
          };
          this.$api2
            .post("/erp/company/", postForm)
            .then(res => {
              this.$c.success(this.$t("prompt.success")).then(()=>{
                this.visible = false;
                this.$emit("refreshDataList");
              })
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
